import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor() { }
  Get_CustomerID():string{
    var returnurl : string = "";
      returnurl = "5fd27548b384e23498aabbcf";
      return returnurl;
  }
  Get_LoginURL():string{
    var returnurl : string = "";
      returnurl = "http://localhost:3000/api/login";
      return returnurl;
  }

  Get_GeneralInfoURL():string{
    var returnurl : string = "";
      returnurl = "http://localhost:3000/api/generalinfo";
      return returnurl;
  }

  Get_APIURL():string{
    var returnurl : string = "";
    returnurl = "https://cargolean.com:443" ;
     //returnurl = "http://tradelink.skyversa.com:4441/api" ;

      return returnurl;
  }

}
